<template>
  <el-row :gutter="10">
    <el-col :span="6">
      <left-table />
    </el-col>
    <el-col :span="18">
      <right-table />
    </el-col>
  </el-row>
</template>
<script>
import LeftTable from './components/left-table/index.vue'
import RightTable from './components/right-table/index.vue'
export default {
  name: 'design-elementsInputTemplate',
  components: {
    LeftTable,
    RightTable,
  },
}
</script>


<!--<template>
  <div class="card-form">
    <div>
      <page-header
        @loadCategoryData="loadCategoryData"
        @reset="reset"
        @add="add"
        @submit="handleSubmit"
        slot="header"
        ref="header"
      />
    </div>
    <page-main
      ref="main"
      :category-table-data="categoryTableData"
      :table-data="table"
      :categoryLoading="categoryLoading"
      :loading="loading"
      @categoryClick="getMainTableData"
      @submit="reload"
    />

    <b-row>
      <b-col>
        <js-pagination
          class="mt-2"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          size="sm"
          align="right"
          @change="handlePaginationChange"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'design-elementsInputTemplate',
  components: {
    PageHeader: () => import('./components/header/index'),
    PageMain: () => import('./components/main')
  },
  data() {
    return {
      table: [],
      loading: false,
      categoryLoading: false,
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      },
      // category
      page_2: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      },
      categoryTableData: []
    }
  },
  methods: {
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      }
      this.$nextTick(() => {
        this.$refs.main.clearSelected()
      })
    },
    //加载分类数据
    loadCategoryData() {
      this.categoryLoading = true
      let page = {
        curPage: 1,
        pageSize: 99
      }
      this.$api
        .listDesignElementsCategoryApi({ deCategoryStatusList: ['Y'], ...page })
        .then((res) => {
          this.categoryTableData = res.body.data
          this.categoryLoading = false
        })
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 重载表格数据
    reload() {
      this.$refs.header.query()
    },
    getMainTableData(form) {
      this.$refs.header.assign(form)
      this.handleSubmit(form)
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .listDesignElementsInputTemplateApi({
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    add() {
      this.$refs.main.fromLoad('add')
    }
  }
}
</script>-->
